/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_CopyInputs */

const en_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const fr_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const de_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopie`)
};

const it_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia`)
};

const ru_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копия`)
};

const es_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const zh_cn2_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const ja_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

const hi_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_shortcut_keys_name_copy = /** @type {(inputs: Shortcut_Keys_Name_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Shortcut_Keys_Name_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_copy = /** @type {((inputs?: Shortcut_Keys_Name_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_copy(inputs)
	if (locale === "de") return de_shortcut_keys_name_copy(inputs)
	if (locale === "it") return it_shortcut_keys_name_copy(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_copy(inputs)
	if (locale === "es") return es_shortcut_keys_name_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_copy(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_copy(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_copy(inputs)
	return en_shortcut_keys_name_copy(inputs)
});